import React, {useState} from "react";
import {ButtonDropdown, DropdownItem, DropdownMenu, DropdownToggle} from "reactstrap";
import IconLabel from "../../../shared/components/IconLabel";
import {LinkIcon, PixIcon, QrIcon, ShareIcon} from "../../../shared/components/icons";

/**
 * The "Compartilhar" menu beside the title: copy the customer's link or the
 * Pix code, or show its QR code. Each is offered when the API lists it (`link`, `pix` in
 * `available_actions`); nothing is shown when it offers neither.
 * @param {{
 *   order: import("../../../api/types").Order,
 *   share: ReturnType<typeof import("./useShare").useShare>,
 * }} props
 */
const ShareMenu = ({order, share}) => {
    const [open, setOpen] = useState(false);
    const available = order.available_actions ?? [];
    const hasLink = available.includes("link");
    const hasPix = available.includes("pix");

    if (!hasLink && !hasPix) return null;

    // `inNavbar`: see OrderMenu.
    return (
        <ButtonDropdown inNavbar isOpen={open} toggle={() => setOpen((value) => !value)}>
            <DropdownToggle caret color="primary" outline size="sm">
                <IconLabel icon={<ShareIcon />}>Compartilhar</IconLabel>
            </DropdownToggle>
            <DropdownMenu end>
                {hasLink && (
                    <DropdownItem onClick={share.copyLink}>
                        <IconLabel icon={<LinkIcon />}>Copiar link</IconLabel>
                    </DropdownItem>
                )}
                {hasPix && (
                    <>
                        <DropdownItem onClick={share.copyPix} disabled={share.pixBusy}>
                            <IconLabel icon={<PixIcon size={16} />}>Gerar Pix</IconLabel>
                        </DropdownItem>
                        <DropdownItem onClick={share.showQr} disabled={share.pixBusy}>
                            <IconLabel icon={<QrIcon />}>QR code Pix</IconLabel>
                        </DropdownItem>
                    </>
                )}
            </DropdownMenu>
        </ButtonDropdown>
    );
};

export default ShareMenu;
